// PATH: src/router/guard.tsx
import * as React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { REVIEWER_HOME, canVisit } from "../auth/access";

function Splash() {
  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
      <CircularProgress size={28} />
    </Box>
  );
}

/** Exige un utilisateur authentifié, admin ou relecteur, sinon redirige vers /login. */
export function RequireAuth() {
  const { status, access } = useAuth();
  const location = useLocation();

  if (status === "unknown") return <Splash />;
  // Non connecté, ou session valide (cookie partagé .tilmicode.com) mais ni
  // admin ni relecteur : /login affiche alors le message d'accès refusé.
  if (status === "anonymous" || access === "none") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Relecteur sur un écran qui ne lui est pas ouvert (catalogue, réglages).
  if (!canVisit(access, location.pathname)) return <Navigate to={REVIEWER_HOME} replace />;
  return <Outlet />;
}

/** Déjà authentifié (admin ou relecteur) : /login renvoie vers l'accueil. Un
 *  compte sans accès reste sur /login (sinon boucle de redirection avec RequireAuth). */
export function RedirectIfAuthed({ children }: { children: React.ReactElement }) {
  const { status, access } = useAuth();
  // Pas de Splash pendant une tentative de connexion : il démonterait le
  // formulaire et effacerait le message d'erreur.
  if (status === "unknown") return <Splash />;
  if (status === "authenticated" && access !== "none") return <Navigate to="/" replace />;
  return children;
}
